import { createSelector } from '@ngrx/store';

export enum BuysideUserSettingsTypes {
  defaultFlexColumn = 'defaultFlexColumn',
  defaultBenchmarkCurve = 'defaultBenchmarkCurve',
  defaultMarginalTaxRate = 'defaultMarginalTaxRate',
  defaultCalendarFollowShortcut = 'defaultCalendarFollowAssignmentShortcut',
  defaultDealManagerView = 'defaultDealManagerView',
  defaultCalendarRatingsView = 'defaultCalendarRatingsView'
}

export interface BuysideMuniUserSetting {
  id: string;
  userPreference: UserPreference;
}

interface UserPreference {
  name: BuysideUserSettingsTypes;
  value: string;
}

export interface BuysideSharedModelState {
  muniUserSettings: {
    settings: BuysideMuniUserSetting[];
    filters: BuysideMuniUserSetting[];
  };
}

export interface BuysideSharedState {
  shared: BuysideSharedModelState;
}

export const selectBuysideSharedState = createSelector(
  (state: Record<string, unknown>) => state.shared,
  (value) => value
);

export const getBuysideMuniUserSettingsState = createSelector(
  selectBuysideSharedState,
  (state: BuysideSharedModelState) => state && state.muniUserSettings.settings
);
